(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"] && !Shopify.designMode) return;
  try {
    
// "Add product to next order" button — routes through the storefront API on
// Laravel (MillsDogDashboard.api.addAddon → PATCH /storefront/me/dogs/{id}/addons/add)
// instead of the legacy NestJS endpoint. The api object handles the bearer
// token + CORS, so this code stays small.
document.addEventListener("click", function (e) {
  var btn = e.target.closest("#mc-add-next-order");
  if (!btn) return;
  e.preventDefault();

  var dogId = String(btn.getAttribute("data-dog") || "");
  if (dogId.indexOf("/") !== -1) dogId = dogId.split("/").pop();
  if (!dogId) { return; }

  var label = "הוספת המוצר להזמנה הקרובה";
  btn.disabled = true;
  btn.textContent = "מוסיף…";

  function isSubLine(it) {
    if (!it || it.handle === "subs-test") return true;
    var p = it.properties;
    if (!p) return false;
    if (Array.isArray(p)) return p.some(function (x) { return x && x.name === "חידוש"; });
    return Object.prototype.hasOwnProperty.call(p, "חידוש");
  }
  function lineName(it) {
    var n = it.product_title || "";
    if (it.variant_title && it.variant_title !== "Default Title") n += " - " + it.variant_title;
    return n || "מוצר";
  }
  function api() {
    return window.MillsDogDashboard && window.MillsDogDashboard.api;
  }

  if (!api() || typeof api().addAddon !== "function") {
    btn.disabled = false;
    btn.textContent = label;
    alert("השירות לא זמין כרגע — רענן את הדף ונסה שוב");
    return;
  }

  fetch("/cart.js")
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var items = (cart && cart.items) || [];
      var chain = Promise.resolve();
      items.forEach(function (item) {
        if (isSubLine(item)) return;
        var vid = String(item.variant_id);
        var nm = lineName(item);
        var q = Math.max(1, parseInt(item.quantity, 10) || 1);
        for (var i = 0; i < q; i++) {
          chain = chain.then(
            (function (v, n) {
              return function () {
                return api().addAddon(dogId, v, n);
              };
            })(vid, nm)
          );
        }
      });
      return chain;
    })
    .then(function () {
      btn.textContent = "נוסף";
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2000);
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      var msg = (err && err.body && err.body.message) || (err && err.message) || "לא ניתן להוסיף — נסו שוב";
      if (err && err.code === "icount_requires_card_update") {
        msg = "יש לעדכן אמצעי תשלום לפני הוספת מוצרים למנוי.";
      }
      alert(msg);
    });
});

  } catch(e) { console.error(e); }
})();
})();
